// Renders a banner at the top of the screen - can be used for system notifications, emergency alerts, etc.
// See NotificationContext for implementation details

// Dependencies
import React, { useCallback } from 'react';

// Material Components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// Hooks
import { useNotifications } from 'hooks/useNotifications';

function Notifications() {
  const { notifications, clearNotifications } = useNotifications();

  const handleClose = useCallback(
    () => {
      clearNotifications();
    },
    [clearNotifications]
  );

  if (!notifications.length) return null;

  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        alignItems: 'center',
        justifyContent: 'space-between',
        color: (theme) => theme.palette.primary.contrastText,
        backgroundColor: (theme) => theme.palette.primary.main,
        marginBottom: 2
      }}
    >
      <Box>
        {notifications.map(n => (
          <Typography key={n.type}>{n.message}</Typography>
        ))}
      </Box>

      <IconButton
        aria-label="notification-close-button"
        sx={{
          color: (theme) => theme.palette.primary.contrastText,
          '&:hover': {
            backgroundColor: (theme) => theme.palette.primary.contrastText,
          },
        }}

        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>


    </Box>
  )
}

export { Notifications };